module.exports = __webpack_public_path__ + "img/category-10.961c16d5.svg";